import React from 'react';
import PropTypes from 'prop-types';

function SocialLink(props) {
  const { onClick, buttonClass, children } = props;
  return (
    <button type="button" onClick={onClick} className={buttonClass}>
      {children}
    </button>
  );
}

SocialLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttonClass: PropTypes.string,
  children: PropTypes.node.isRequired,
};

SocialLink.defaultProps = {
  buttonClass: 'social-link-button',
};
export default SocialLink;
